// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.split-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 24px;
}

.split-modal {
  background: var(--color-surface-light, #fff);
  color: var(--color-primary, #111);
  border-radius: 12px;
  width: min(100%, 640px);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

/* Wider modal when the PDF pane is present. */
.split-modal--with-pdf {
  width: min(100%, 1200px);
  height: min(100%, 900px);
}

.split-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 24px 12px;
  border-bottom: 1px solid var(--color-surface-dark, #e2e8f0);
}

.split-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.split-modal__subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--color-text-secondary, #64748b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 480px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.split-modal__page-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--color-surface-dark, #e2e8f0);
  color: var(--color-text-secondary, #475569);
  font-weight: 500;
}

.split-modal__close {
  border: none;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: var(--color-text-secondary, #64748b);
  padding: 4px 8px;
}
.split-modal__close:disabled { opacity: 0.4; cursor: not-allowed; }

/* Body layout — single column by default, two-column with PDF pane. */
.split-modal__body {
  padding: 16px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-height: 0;
}

.split-modal--with-pdf .split-modal__body {
  flex-direction: row;
  gap: 20px;
  overflow: hidden;
}

@media (max-width: 900px) {
  .split-modal--with-pdf .split-modal__body {
    flex-direction: column;
    overflow-y: auto;
  }
}

.split-modal__pdf-pane {
  flex: 1 1 55%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
}

.split-modal__pdf-hint {
  font-size: 12px;
  color: var(--color-text-secondary, #64748b);
  padding: 0 4px;
}

.split-modal__parts-pane {
  flex: 1 1 45%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  padding-right: 4px;
}

.split-modal__page-count {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.split-modal__page-count label {
  font-size: 13px;
  font-weight: 500;
}
.split-modal__page-count input {
  width: 140px;
  padding: 6px 10px;
  border: 1px solid var(--color-surface-dark, #cbd5e1);
  border-radius: 6px;
  font-size: 14px;
  background: var(--color-surface-light, #fff);
  color: inherit;
}
.split-modal__hint {
  font-size: 12px;
  color: var(--color-text-secondary, #64748b);
}

.split-modal__parts {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.split-modal__part {
  border: 2px solid var(--color-surface-dark, #e2e8f0);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: var(--color-surface-light, #fff);
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

/* Focused part: colored border driven by inline style (per-part color). */
.split-modal__part--focused {
  box-shadow: 0 0 0 2px rgba(88, 166, 255, 0.15);
}

.split-modal__part-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.split-modal__part-swatch {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.split-modal__part-num {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-secondary, #475569);
}

.split-modal__part-count {
  font-size: 11px;
  color: var(--color-text-secondary, #64748b);
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--color-surface-dark, #f1f5f9);
  margin-left: auto;
}

.split-modal__remove {
  border: none;
  background: transparent;
  color: #b91c1c;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 6px;
}
.split-modal__remove:disabled { opacity: 0.4; cursor: not-allowed; }

.split-modal__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
}
.split-modal__field span {
  font-weight: 500;
}
.split-modal__field input {
  padding: 6px 10px;
  border: 1px solid var(--color-surface-dark, #cbd5e1);
  border-radius: 6px;
  font-size: 14px;
  background: var(--color-surface-light, #fff);
  color: inherit;
}
.split-modal__field input[aria-invalid="true"] {
  border-color: #dc2626;
}

.split-modal__row-error {
  color: #b91c1c;
  font-size: 12px;
}

.split-modal__add {
  align-self: flex-start;
  border: 1px dashed var(--color-surface-dark, #cbd5e1);
  background: transparent;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  color: var(--color-secondary, #475569);
}
.split-modal__add:disabled { opacity: 0.4; cursor: not-allowed; }

.split-modal__warning {
  background: rgba(250, 204, 21, 0.1);
  color: #92400e;
  border: 1px solid rgba(250, 204, 21, 0.4);
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.split-modal__warning-hint {
  font-size: 12px;
  opacity: 0.8;
}

.split-modal__error {
  background: rgba(220, 38, 38, 0.08);
  color: #b91c1c;
  border: 1px solid rgba(220, 38, 38, 0.3);
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
}

.split-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 24px 20px;
  border-top: 1px solid var(--color-surface-dark, #e2e8f0);
}

.split-modal__btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
}
.split-modal__btn:disabled { opacity: 0.5; cursor: not-allowed; }

.split-modal__btn--ghost {
  background: transparent;
  border-color: var(--color-surface-dark, #cbd5e1);
  color: inherit;
}

.split-modal__btn--primary {
  background: var(--color-secondary, #4c6a58);
  color: #fff;
}

/* ─── PDF thumbnail grid ─── */

.pdf-grid {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  padding: 4px;
  align-content: start;
  background: var(--color-surface-dark, #f1f5f9);
  border-radius: 6px;
  min-height: 300px;
}

.pdf-grid__status {
  padding: 24px;
  text-align: center;
  color: var(--color-text-secondary, #64748b);
  font-size: 13px;
  grid-column: 1 / -1;
}
.pdf-grid__status--error {
  color: #b91c1c;
}

.pdf-grid__tile {
  position: relative;
  border: 2px solid transparent;
  border-radius: 4px;
  padding: 0;
  background: #fff;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  justify-content: center;
  transition: transform 0.1s ease, border-color 0.15s ease;
}

.pdf-grid__tile:hover:not(:disabled) {
  transform: translateY(-1px);
  border-color: rgba(88, 166, 255, 0.5);
}

.pdf-grid__tile--claimed {
  /* Border color set inline based on part color */
}

.pdf-grid__page-num {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 500;
}

.pdf-grid__page-loading {
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: pdf-shimmer 1.4s ease-in-out infinite;
}

@keyframes pdf-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
`, "",{"version":3,"sources":["webpack://./src/modules/document-manager/components/SplitDocumentModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,2DAA2D;AAC7D;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;EAC9C,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;AAClB;AACA,+BAA+B,YAAY,EAAE,mBAAmB,EAAE;;AAElE,sEAAsE;AACtE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,oDAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C,cAAc;AAChB;AACA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4CAA4C;EAC5C,eAAe;EACf,0DAA0D;AAC5D;;AAEA,0EAA0E;AAC1E;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA,gCAAgC,YAAY,EAAE,mBAAmB,EAAE;;AAEnE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oDAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;AACA,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;;AAEhE;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;AACA,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;;AAEhE;EACE,uBAAuB;EACvB,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA,+BAA+B;;AAE/B;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC","sourcesContent":[".split-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  padding: 24px;\n}\n\n.split-modal {\n  background: var(--color-surface-light, #fff);\n  color: var(--color-primary, #111);\n  border-radius: 12px;\n  width: min(100%, 640px);\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n/* Wider modal when the PDF pane is present. */\n.split-modal--with-pdf {\n  width: min(100%, 1200px);\n  height: min(100%, 900px);\n}\n\n.split-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 20px 24px 12px;\n  border-bottom: 1px solid var(--color-surface-dark, #e2e8f0);\n}\n\n.split-modal__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.split-modal__subtitle {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: var(--color-text-secondary, #64748b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 480px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.split-modal__page-badge {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--color-surface-dark, #e2e8f0);\n  color: var(--color-text-secondary, #475569);\n  font-weight: 500;\n}\n\n.split-modal__close {\n  border: none;\n  background: transparent;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--color-text-secondary, #64748b);\n  padding: 4px 8px;\n}\n.split-modal__close:disabled { opacity: 0.4; cursor: not-allowed; }\n\n/* Body layout — single column by default, two-column with PDF pane. */\n.split-modal__body {\n  padding: 16px 24px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n}\n\n.split-modal--with-pdf .split-modal__body {\n  flex-direction: row;\n  gap: 20px;\n  overflow: hidden;\n}\n\n@media (max-width: 900px) {\n  .split-modal--with-pdf .split-modal__body {\n    flex-direction: column;\n    overflow-y: auto;\n  }\n}\n\n.split-modal__pdf-pane {\n  flex: 1 1 55%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  overflow: hidden;\n}\n\n.split-modal__pdf-hint {\n  font-size: 12px;\n  color: var(--color-text-secondary, #64748b);\n  padding: 0 4px;\n}\n\n.split-modal__parts-pane {\n  flex: 1 1 45%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.split-modal__page-count {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.split-modal__page-count label {\n  font-size: 13px;\n  font-weight: 500;\n}\n.split-modal__page-count input {\n  width: 140px;\n  padding: 6px 10px;\n  border: 1px solid var(--color-surface-dark, #cbd5e1);\n  border-radius: 6px;\n  font-size: 14px;\n  background: var(--color-surface-light, #fff);\n  color: inherit;\n}\n.split-modal__hint {\n  font-size: 12px;\n  color: var(--color-text-secondary, #64748b);\n}\n\n.split-modal__parts {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.split-modal__part {\n  border: 2px solid var(--color-surface-dark, #e2e8f0);\n  border-radius: 8px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: var(--color-surface-light, #fff);\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n/* Focused part: colored border driven by inline style (per-part color). */\n.split-modal__part--focused {\n  box-shadow: 0 0 0 2px rgba(88, 166, 255, 0.15);\n}\n\n.split-modal__part-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.split-modal__part-swatch {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.split-modal__part-num {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-secondary, #475569);\n}\n\n.split-modal__part-count {\n  font-size: 11px;\n  color: var(--color-text-secondary, #64748b);\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--color-surface-dark, #f1f5f9);\n  margin-left: auto;\n}\n\n.split-modal__remove {\n  border: none;\n  background: transparent;\n  color: #b91c1c;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 4px 6px;\n}\n.split-modal__remove:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.split-modal__field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n}\n.split-modal__field span {\n  font-weight: 500;\n}\n.split-modal__field input {\n  padding: 6px 10px;\n  border: 1px solid var(--color-surface-dark, #cbd5e1);\n  border-radius: 6px;\n  font-size: 14px;\n  background: var(--color-surface-light, #fff);\n  color: inherit;\n}\n.split-modal__field input[aria-invalid=\"true\"] {\n  border-color: #dc2626;\n}\n\n.split-modal__row-error {\n  color: #b91c1c;\n  font-size: 12px;\n}\n\n.split-modal__add {\n  align-self: flex-start;\n  border: 1px dashed var(--color-surface-dark, #cbd5e1);\n  background: transparent;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--color-secondary, #475569);\n}\n.split-modal__add:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.split-modal__warning {\n  background: rgba(250, 204, 21, 0.1);\n  color: #92400e;\n  border: 1px solid rgba(250, 204, 21, 0.4);\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 13px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.split-modal__warning-hint {\n  font-size: 12px;\n  opacity: 0.8;\n}\n\n.split-modal__error {\n  background: rgba(220, 38, 38, 0.08);\n  color: #b91c1c;\n  border: 1px solid rgba(220, 38, 38, 0.3);\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.split-modal__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 24px 20px;\n  border-top: 1px solid var(--color-surface-dark, #e2e8f0);\n}\n\n.split-modal__btn {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n.split-modal__btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.split-modal__btn--ghost {\n  background: transparent;\n  border-color: var(--color-surface-dark, #cbd5e1);\n  color: inherit;\n}\n\n.split-modal__btn--primary {\n  background: var(--color-secondary, #4c6a58);\n  color: #fff;\n}\n\n/* ─── PDF thumbnail grid ─── */\n\n.pdf-grid {\n  flex: 1;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 12px;\n  padding: 4px;\n  align-content: start;\n  background: var(--color-surface-dark, #f1f5f9);\n  border-radius: 6px;\n  min-height: 300px;\n}\n\n.pdf-grid__status {\n  padding: 24px;\n  text-align: center;\n  color: var(--color-text-secondary, #64748b);\n  font-size: 13px;\n  grid-column: 1 / -1;\n}\n.pdf-grid__status--error {\n  color: #b91c1c;\n}\n\n.pdf-grid__tile {\n  position: relative;\n  border: 2px solid transparent;\n  border-radius: 4px;\n  padding: 0;\n  background: #fff;\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  transition: transform 0.1s ease, border-color 0.15s ease;\n}\n\n.pdf-grid__tile:hover:not(:disabled) {\n  transform: translateY(-1px);\n  border-color: rgba(88, 166, 255, 0.5);\n}\n\n.pdf-grid__tile--claimed {\n  /* Border color set inline based on part color */\n}\n\n.pdf-grid__page-num {\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-weight: 500;\n}\n\n.pdf-grid__page-loading {\n  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);\n  background-size: 200% 100%;\n  animation: pdf-shimmer 1.4s ease-in-out infinite;\n}\n\n@keyframes pdf-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
